import { api } from "./client";

export interface Meta {
  /** "dev" | "prod" — the backend's DELEGGATE_ENV. */
  env: string;
  /** true only for the all-in-one `deleggate dev` binary. */
  devServer: boolean;
  /** true when running the cloud tier (plans/quotas/billing enforced). */
  cloud: boolean;
}

export const metaApi = {
  get: () => api<Meta>("/api/meta"),
};
